<template>
  <v-responsive>
    <v-app>
      <!-- {{ $user.value }} -->
      <v-app-bar :elevation="0" class="main-nav" color="tertiary" v-if="$user.value != null"
        :extension-height="$globalState.screenWidth == 'xs' ? 80 : 60" data-app>

        <template v-slot:extension v-if="isMenuOpen">
          <v-row justify="space-around" class="mx-8">
            <v-container class="nav-buttons text-center" group>
              <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER') && ['published','created','pending'].includes($getPublicityState())"
                :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/home') }"
                variant="plain" :ripple="false" @click="(setActive(index), router.push('/shop/home'))">
                {{ $t('global.menu.dealer.home') }}
              </v-btn>
              <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER') && ['published','created','pending'].includes($getPublicityState())"
                :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/favorites') }"
                variant="plain" :ripple="false" @click="(setActive(index), router.push('/shop/favorites'))">
                {{ $t('global.menu.dealer.favorites') }}
              </v-btn>
              <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER')"
                :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/profile') }"
                variant="plain" :ripple="false"
                @click="(setActive(index), router.push({ path: `/shop/profile`, query: { editMode: true } }))">
                {{ $t('global.menu.dealer.main') }}
              </v-btn>
              <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER')"
                :class="{ active: activeIndex === menuItems.findIndex(item => item.url === '#') }" variant="plain"
                :ripple="false" @click="openTopDialog()">
                {{ $t('global.menu.dealer.inbox') }}
              </v-btn>
            </v-container>

            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">
                  {{ $t('global.menu.dealer.membership') }} <v-icon icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="router.push('/settings')">
                  <v-list-item-title>{{ $t('global.menu.account.settings') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="router.push('/password')">
                  <v-list-item-title>{{ $t('global.menu.account.password') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="createShopNews()">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.news') }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="openDialog">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.voucher') }}</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="router.push({ path: '/shop/profile', query: { editMode: true } })">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.profile') }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="router.push('/shop/subscription')">
                  <v-list-item-title>{{ $t('global.menu.account.subs') }}</v-list-item-title>
                </v-list-item> -->
                <v-list-item href="https://findeling.zendesk.com/hc/de-de">
                  <v-list-item-title>Helpcenter</v-list-item-title>
                </v-list-item>
                <v-list-item @click="logout()">
                  <v-list-item-title>{{ $t('global.menu.account.logout') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu location="bottom" class="language-picker" v-if="$hasRole('ROLE_ADMINISTRATOR')">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">
                  {{$t('global.menu.backoffice.main')}}
                  <!-- <v-icon icon="mdi-menu-down"></v-icon> -->
                </v-btn>
              </template>

              <v-list density="compact">
                <v-list-item @click="$router.push({ name: 'backoffice.register' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.register') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.upgrade-user' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.user') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.manage-user' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.manageUsers') }}</v-list-item-title>
                </v-list-item>

                <v-list-item @click="$router.push({ name: 'backoffice.userPosts' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.userPosts') }}</v-list-item-title>
                </v-list-item>
              
                <!-- <v-list-item @click="$router.push({ name: 'backoffice.masterdata.admins' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.admin') }}</v-list-item-title>
                </v-list-item> -->
              
                <v-list-item @click="$router.push({ name: 'backoffice.shops' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.shops') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.premium-features' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.premium-features') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.country' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.countries') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.brands' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.brands') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.streamcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.streamCategories') }}</v-list-item-title>
                </v-list-item>

                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.labels' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.labels') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.labelcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.labelCategories') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.productcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.productcategory') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.productgroup' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.productgroup') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.attribute' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.attribute') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.voucher' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.voucher') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.pushnotifications' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.push-notifications') }}</v-list-item-title>
                </v-list-item>
                
                <v-list-item @click="refreshElastic()">
                  <v-list-item-title>{{ $t('global.menu.backoffice.refresh.elastic') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </template>
        <template v-slot:append>
          <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
          <template v-if="['xs', 'sm'].includes($globalState.screenWidth)">
            <v-app-bar-nav-icon @click="isMenuOpen = !isMenuOpen"></v-app-bar-nav-icon>
          </template>
          <template v-else>
            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">
                  {{ $t('global.menu.dealer.membership') }} <v-icon icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="router.push('/settings')">
                  <v-list-item-title>{{ $t('global.menu.account.settings') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="router.push('/password')">
                  <v-list-item-title>{{ $t('global.menu.account.password') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="createShopNews()">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.news') }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="openDialog">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.voucher') }}</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="router.push({ path: '/shop/profile', query: { editMode: true } })">
                  <v-list-item-title>{{ $t('shop.home.widgets.actions.profile') }}</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="router.push('/shop/subscription')">
                  <v-list-item-title>{{ $t('global.menu.account.subs') }}</v-list-item-title>
                </v-list-item> -->
                <v-list-item href="https://findeling.zendesk.com/hc/de-de">
                  <v-list-item-title>Helpcenter</v-list-item-title>
                </v-list-item>
                <v-list-item @click="logout()">
                  <v-list-item-title>{{ $t('global.menu.account.logout') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu location="bottom" class="language-picker">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">
                  <img :src="selectedLanguage.img" height="24" width="24"> {{ selectedLanguage.title }}<v-icon
                    icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item :class="{ 'active': selectedLanguage.title == lang.title }"
                  v-for="(lang, index) in languages" :key="index" @click="selectOption(lang)">
                  <v-list-item-title><img :src="lang.img" height="24" width="24"> {{ lang.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn v-if="isImpersonating" color="error" @click="() => revertToSuperUser()" icon="mdi-power" variant="flat"></v-btn>
            <v-menu location="bottom" class="language-picker" v-if="$hasRole('ROLE_ADMINISTRATOR')">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props">
                  {{$t('global.menu.backoffice.main')}}
                  <!-- <v-icon icon="mdi-menu-down"></v-icon> -->
                </v-btn>
              </template>

              <v-list density="compact">
                <v-list-item @click="$router.push({ name: 'backoffice.register' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.register') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.upgrade-user' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.user') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.manage-user' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.manageUsers') }}</v-list-item-title>
                </v-list-item>

                <v-list-item @click="$router.push({ name: 'backoffice.userPosts' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.userPosts') }}</v-list-item-title>
                </v-list-item>
              
                <!-- <v-list-item @click="$router.push({ name: 'backoffice.masterdata.admins' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.admin') }}</v-list-item-title>
                </v-list-item> -->
              
                <v-list-item @click="$router.push({ name: 'backoffice.shops' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.shops') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.premium-features' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.premium-features') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.country' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.countries') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.brands' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.brands') }}</v-list-item-title>
                </v-list-item>

                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.streamcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.streamCategories') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.labels' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.labels') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.labelcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.labelCategories') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.productcategory' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.productcategory') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.productgroup' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.productgroup') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.attribute' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.attribute') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.voucher' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.voucher') }}</v-list-item-title>
                </v-list-item>
              
                <v-list-item @click="$router.push({ name: 'backoffice.masterdata.pushnotifications' })">
                  <v-list-item-title>{{ $t('global.menu.backoffice.push-notifications') }}</v-list-item-title>
                </v-list-item>

                <v-list-item @click="refreshElastic()">
                  <v-list-item-title>{{ $t('global.menu.backoffice.refresh.elastic') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </template>

        <!-- const menuItems = [
          { label: t('global.menu.dealer.home'), url: 'shop/home' },
          { label: t('global.menu.dealer.favorites'), url: 'shop/favorites' },
          { label: t('global.menu.dealer.main'), url: 'shop/profile' },
          { label: t('global.menu.dealer.inbox'), url: '#' },
        ]; -->

        <template v-slot:title v-if="!['xs', 'sm'].includes($globalState.screenWidth)">
          <v-container class="nav-buttons text-center" group>
            <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER') && ['published','created','pending'].includes($getPublicityState())"
              :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/home') }" variant="plain"
              :ripple="false" @click="(setActive(index), router.push('/shop/home'))">
              {{ $t('global.menu.dealer.home') }}
            </v-btn>
            <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER') && ['published','created','pending'].includes($getPublicityState())"
              :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/favorites') }"
              variant="plain" :ripple="false" @click="(setActive(index), router.push('/shop/favorites'))">
              {{ $t('global.menu.dealer.favorites') }}
            </v-btn>
            <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER')"
              :class="{ active: activeIndex === menuItems.findIndex(item => item.url === 'shop/profile') }"
              variant="plain" :ripple="false"
              @click="(setActive(index), router.push({ path: `/shop/profile`, query: { editMode: true } }))">
              {{ $t('global.menu.dealer.main') }}
            </v-btn>
            <v-btn class="nav-btn" v-if="$hasRole('ROLE_DEALER')"
              :class="{ active: activeIndex === menuItems.findIndex(item => item.url === '#') }" variant="plain"
              :ripple="false" @click="openTopDialog()">
              {{ $t('global.menu.dealer.inbox') }}
            </v-btn>
          </v-container>
        </template>

        <template v-slot:prepend>
          <v-responsive>
            <img @click="router.push(`/`)" class="logo" src="/images/logo.png">
          </v-responsive>

          <v-menu location="bottom" class="language-picker" v-if="['xs', 'sm'].includes($globalState.screenWidth)">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props">
                <img :src="selectedLanguage.img" height="24" width="24" class="ml-3"> {{ selectedLanguage.title
                }}<v-icon icon="mdi-menu-down"></v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item :class="{ 'active': selectedLanguage.title == lang.title }"
                v-for="(lang, index) in languages" :key="index" @click="selectOption(lang)">
                <v-list-item-title><img :src="lang.img" height="24" width="24"> {{ lang.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

      </v-app-bar>

      <!-- APP BAR FOR NON USER -->
      <v-app-bar v-else :elevation="0" class="main-nav" color="primary" absolute
        :extension-height="$globalState.screenWidth == 'xs' ? 80 : 60" data-app>
        <template v-slot:extension v-if="isMenuOpen">
          <v-card height="200">

          </v-card>
          <v-row justify="space-around" class="mx-8">

            <v-btn variant="text" :ripple="false" elevation="0" target="_blank"
              href="https://www.findeling.city/collections/mitgliedschaften">
              {{ $t('register_shop') }}
            </v-btn>

            <v-menu location="bottom" class="language-picker">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" :ripple="false" elevation="0">
                  <img :src="selectedLanguage.img" height="24" width="24"> {{ selectedLanguage.title }}<v-icon
                    icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item :class="{ 'active': selectedLanguage.title == lang.title }"
                  v-for="(lang, index) in languages" :key="index" @click="selectOption(lang)">
                  <v-list-item-title><img :src="lang.img" height="24" width="24"> {{ lang.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" :ripple="false" elevation="0">
                  {{ $t('global.menu.common.about') }} <v-icon icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item target="_blank" href="https://blog.findeling.de/">
                  <v-list-item-title>{{ $t('global.menu.common.about-main') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$router.push(`/${selectedArea.urlName}/suche/produktgruppe/Findeling-Gutscheine`)">
                  <v-list-item-title>{{ $t('global.menu.common.redeemVoucher') }}</v-list-item-title>
                </v-list-item>
                <v-divider class="my-2"></v-divider>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/datenschutzrichtlinie">
                  <v-list-item-title>{{ $t('global.menu.common.datenschutz') }}</v-list-item-title>
                </v-list-item>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/agb/tandc">
                  <v-list-item-title>{{ $t('global.menu.common.agb') }}</v-list-item-title>
                </v-list-item>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/impressum/imprint">
                  <v-list-item-title>{{ $t('global.menu.common.impressum') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>



            <v-btn variant="text" :ripple="false" elevation="0" @click="$router.push('/login')">
              {{ $t('global.menu.account.login') }}
            </v-btn>
          </v-row>
        </template>
        <template v-slot:append>
          <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

          <template v-if="['xs', 'sm'].includes($globalState.screenWidth)">
            <v-app-bar-nav-icon @click="isMenuOpen = !isMenuOpen"></v-app-bar-nav-icon>
          </template>


          <template v-else>

            <v-btn variant="text" :ripple="false" elevation="0" target="_blank"
              href="https://www.findeling.city">
              {{ $t('register_shop') }}
            </v-btn>

            <v-menu location="bottom" class="language-picker">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" :ripple="false" elevation="0">
                  <img :src="selectedLanguage.img" height="24" width="24"> {{ selectedLanguage.title }}<v-icon
                    icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item :class="{ 'active': selectedLanguage.title == lang.title }"
                  v-for="(lang, index) in languages" :key="index" @click="selectOption(lang)">
                  <v-list-item-title><img :src="lang.img" height="24" width="24"> {{ lang.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" :ripple="false" elevation="0">
                  Über Findeling <v-icon icon="mdi-menu-down"></v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item target="_blank" href="https://blog.findeling.de/">
                  <v-list-item-title>{{ $t('global.menu.common.about-main') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$router.push(`/${selectedArea.urlName}/suche/produktgruppe/Findeling-Gutscheine`)">
                  <v-list-item-title>{{ $t('global.menu.common.redeemVoucher') }}</v-list-item-title>
                </v-list-item>
                <v-divider class="my-2"></v-divider>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/datenschutzrichtlinie">
                  <v-list-item-title>{{ $t('global.menu.common.datenschutz') }}</v-list-item-title>
                </v-list-item>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/agb/tandc">
                  <v-list-item-title>{{ $t('global.menu.common.agb') }}</v-list-item-title>
                </v-list-item>
                <v-list-item target="_blank" href="https://www.findeling.city/pages/impressum/imprint">
                  <v-list-item-title>{{ $t('global.menu.common.impressum') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>



            <v-btn variant="text" :ripple="false" elevation="0" @click="$router.push('/login')">
              {{ $t('global.menu.account.login') }}
            </v-btn>
          </template>
        </template>

        <template v-slot:prepend>
          <v-responsive>
            <img @click="router.push(`/`)" class="logo" src="/images/logo_white.png">
          </v-responsive>
          <v-menu location="bottom" :close-on-content-click="false">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" :ripple="false" elevation="0" class="region-selector">
                {{ selectedArea ? selectedArea.name : "" }} <v-icon icon="mdi-menu-down"></v-icon>
              </v-btn>
            </template>

            <v-list>
              <!-- <template v-slot:header>
                
              </template> -->
              <v-list-subheader>
                <v-row cols="12">
                  <v-col align-self="center">
                    <img v-if="locationType != 'countries' && !countryList" @click="changeCountry()"
                      :src="`/images/flags/flag_${selectedLocation?.code}.png`" height="24" width="24"
                      class="clickable">
                    <v-icon v-else @click="changeCountry()">mdi-close</v-icon>
                    {{ countryList }}
                  </v-col>
                  <v-col>
                    <v-btn-toggle color="primary" v-model="locationType" variant="outlined" rounded="lg" mandatory>
                      <v-btn value="city" :ripple="false">
                        {{ $t('global.menu.cities.main') }}
                      </v-btn>
                      <v-btn value="region" :ripple="false">
                        {{ $t('global.menu.cities.rurals') }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-list-subheader>
              <template v-if="locationType == 'countries'">
                <!-- todo add ToolTip -->
                <v-list-item @click="changeCountry(), selectCountry(country)" v-for="country in filteredCountries"
                  :key="country.id">
                  <v-list-item-title><img :src="`/images/flags/flag_${country.code}.png`" height="24" width="24">
                    {{ country.translations[selectedLanguage.code.toUpperCase()] }}</v-list-item-title>
                </v-list-item>
              </template>

              <template v-if="locationType == 'city'">
                <v-list>
                  <v-list-item active-class="bg-primary" :active="selectedArea?.id == city.id"
                    @click="assignSelectedArea(city)" :value="city" v-for="city in filteredCityAreas" :key="city.id">
                    <v-list-item-title>{{ city.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </template>

              <template v-if="locationType == 'region'">
                <v-list>
                  <v-list-item active-class="bg-primary" :active="selectedArea?.id == area.id"
                    @click="assignSelectedArea(area)" v-for="area in filteredAreas" :key="area.id">
                    <v-list-item-title>{{ area.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </template>

            </v-list>
          </v-menu>
        </template>
      </v-app-bar>

      <!-- <EditShopTour ref="EditShopTourManager" v-if="editShopTourMode"></EditShopTour> -->
      <v-main theme="dark" class="d-flex">
        <router-view></router-view>
      </v-main>


      <v-footer color="#202020" class="footer" tile v-if="showFooter">
        <v-row justify="center" no-gutters>
          <div class="footer-container row justify-content-between">
            <v-col cols="12" md="6" lg="4">
              <h3>Findeling</h3>
              <v-list variant="text" density="compact" bg-color="transparent" class="footer-list" :slim="true"
                base-color="transparent">
                <v-list-item href="/" variant="text">
                  <v-list-item-title>{{ $t('global.menu.home') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.about') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/blog/" variant="text">
                  <v-list-item-title>{{ $t('global.menu.common.blog') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/team/" variant="text">
                  <v-list-item-title>{{ $t('global.menu.common.team') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/kontakt/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.contact') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/agb/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.agb') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/datenschutzrichtlinie/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.data-policy') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/impressum/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.imprint') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <h3>{{ $t('main.footer.shop-owner') }}</h3>
              <v-list variant="text" density="compact" bg-color="transparent" class="footer-list" :slim="true"
                base-color="transparent">
                <v-list-item href="https://www.findeling.city/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.trial') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$router.push('/login')" variant="text">
                  <v-list-item-title>{{ $t('main.footer.shop-login') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  href="https://apps.apple.com/de/app/findeling-f%C3%BCr-ladenbesitzer/id1033194004?ign-mpt=uo%3D2"
                  variant="text">
                  <v-list-item-title>{{ $t('main.footer.ios-app') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://play.google.com/store/apps/details?id=de.findeling.findelshop"
                  variant="text">
                  <v-list-item-title>{{ $t('main.footer.android-app') }}</v-list-item-title>
                </v-list-item>
                <v-list-item href="https://blog.findeling.de/kontakt/" variant="text">
                  <v-list-item-title>{{ $t('main.footer.contact') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="footer-socials">
                <CustomTransitionButton :url="'https://www.facebook.com/findelingeurope'" :icon="'fab fa-facebook-f'"
                  :backgroundColor="'#3b5998'" :hoverColor="'#1a3e72'" :title="'facebook'"></CustomTransitionButton>
                <CustomTransitionButton :url="'https://www.instagram.com/wir.sind.findeling/'"
                  :icon="'fa-brands fa-instagram'" :backgroundColor="'#517fa4'" :hoverColor="'#406582'"
                  :title="'instagram'">
                </CustomTransitionButton>
                <CustomTransitionButton :url="'https://www.linkedin.com/company/findeling-gmbh'"
                  :icon="'fa-brands fa-linkedin-in'" :backgroundColor="'#127bb6'" :hoverColor="'#0D5C88'"
                  :title="'linkedin'">
                </CustomTransitionButton>
              </div>
            </v-col>
          </div>
        </v-row>
      </v-footer>

      <CustomTopSheetDialog v-model="showInbox" :width="900" :title="'Inbox'" :customclass="'text-center'">
        <h4>
          {{ $t('chat.noMessages') }}
        </h4>
      </CustomTopSheetDialog>

      <!-- TODO  
        ROUTING CITY NAMES
        login.json & session.json Functionalities
        Headline Styling
        LoggedIn Header Expansion Full width mobile
        unauthorized push to login
        FULL INBOX FUNCTIONALITIES (NO CLUE YET)
        LOADING When Uploading Image
        DISCOVER DIALOG CHECKING
      -->

      <v-dialog v-model="postOverlay" :content-class="''" :max-width="'1170px'" min-height="85vh" max-height="85vh"
        style="overflow-y: scroll;">
        <v-row justify="center">
          <v-col cols="12" md="8" class="pr-md-0">
            <v-responsive class="" max-height="100%"
              :aspect-ratio="['xs', 'sm'].includes($globalState.screenWidth) ? 2 / 1 : 1 / 1"
              content-class="d-flex align-items-center bg-black h-100">
              <v-carousel contain class="h-100" :show-arrows="selectedPost?.images.length >= 2">
                <v-carousel-item :aspect-ratio="['xs', 'sm'].includes($globalState.screenWidth) ? 2 / 1 : 1 / 1"
                  class="" v-for="post in selectedPost?.images" :key="post.id"
                  :src="`${$cloudFrontApi}${post.id}/STREAM_RETINA`" contain></v-carousel-item>
              </v-carousel>
            </v-responsive>
          </v-col>
          <v-col cols="12" md="4" class="pl-md-0">
            <v-card class="w-100 h-100 d-flex flex-column post-popup" rounded="0" color="#f5f5f5">
              <v-card-item style="background-color: #ededed;">
                <v-list-item class="w-100 text-left px-0" color="#ededed">
                  <template v-slot:prepend>
                    <v-avatar color="grey-darken-3" rounded="0" size="50" class="clickable"
                      :image="`${$cloudFrontApi}${selectedPost.shop ? selectedPost.shop?.avatar : selectedPost.user?.avatar}/AVATAR`"
                      @click="selectedPost?.shop ? ($router.push({ path: `/${selectedArea.urlName}/laden/${selectedPost?.shop?.urlname}`, query: { mode: 'all', lang: selectedLanguage.code.toUpperCase() } }), postOverlay = false) : openDownloadAppHint()"></v-avatar>
                  </template>

                  <v-list-item-title class="mb-2 clickable"
                    @click="selectedPost?.shop ? ($router.push({ path: `/${selectedArea.urlName}/laden/${selectedPost?.shop?.urlname}`, query: { mode: 'all', lang: selectedLanguage.code.toUpperCase() } }), postOverlay = false) : openDownloadAppHint()">{{
                      selectedPost.shop ?selectedPost.shop?.name : selectedPost.user?.username  }}</v-list-item-title>

                  <v-list-item-subtitle>{{ selectedPost?.shop ? selectedPost?.shop.tagline : selectedPost?.user.profile['fields']?.bio?.value ?? "" }}</v-list-item-subtitle>
                </v-list-item>
              </v-card-item>
              <v-card-text>
                <div class="news-post-info d-flex justify-content-between my-2">
                  <span>{{ $t(selectedPost?.category.name ?? selectedPost?.category ?? "") }}</span>

                  <span class="post-start">{{ $getTimeDuration(selectedPost?.lastModified) }}</span>
                </div>
                <h6>{{ selectedPost?.headline }}</h6>
                <p class="news-post-text">
                  {{ selectedPost?.text }}
                </p>
                <v-divider></v-divider>
                <p class="fst-italic" v-if="selectedPost?.productGroups.length >= 1">{{ $t('main.streamwall.full-stream.products') }}
                  {{selectedPost?.productGroups.map(product => product.name).join(', ')
                  }}</p>
                <p class="fst-italic" v-if="selectedPost?.brands.length >= 1">{{ $t('main.streamwall.full-stream.brands') }} {{selectedPost?.brands.map(brand =>
                  brand.name).join(', ')}}</p>
                <v-row>
                  <CustomProductLabel v-for="label in selectedPost?.labels" :key="label.id" :label="label" />
                </v-row>
              </v-card-text>
              <v-card-actions class="mt-auto d-flex flex-column justify-text-left align-start">
                <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-cart-outline"
                  class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.product-link') }}</v-btn>
                <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-mail"
                  class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.contact_store')
                  }}</v-btn>
                <v-btn v-if="selectedPost?.shop != null" variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-phone"
                  class="white--text mb-2" @click="reserve">{{ $t('main.streamwall.full-stream.call_store') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <CustomSocialsShare :share="selectedPost?.shareUrl" :direction="'column'"
          style="position: absolute;right: -32px;bottom: 0;}"></CustomSocialsShare>
      </v-dialog>

      <CreateShopNewsDialog v-model="showShopNewsDialog" :item="shopNewsObject"></CreateShopNewsDialog>
      <CompanyPostDialog v-model="showCompanyPostDialog" :post="companyPost"></CompanyPostDialog>
      <ContactDialog v-model="showContactDialog" :merchant="merchant"></ContactDialog>
      <DiscoverByDialog v-model="showDiscoverDialog" :items="discoverItems" :item="selectedCompanyFilter">
      </DiscoverByDialog>
      <DownloadAppHint v-model="showDownloadAppHint"></DownloadAppHint>


    </v-app>
  </v-responsive>

</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import CustomTopSheetDialog from './components/custom/CustomTopSheetDialog.vue';
import { ref, watch, getCurrentInstance, computed, provide, onMounted } from 'vue'
import CustomTransitionButton from './components/custom/CustomTransitionButton.vue';
import CreateShopNewsDialog from './components/shop/modals/CreateShopNewsDialog.vue';
import CompanyPostDialog from './components/shop/fairling/CompanyPostDialog.vue';
import CustomProductLabel from './components/custom/CustomProductLabel.vue';
import ContactDialog from './components/shop/modals/ContactDialog.vue';
// import { fetchPosts } from './services/apiService';
import { useI18n } from 'vue-i18n';
import DiscoverByDialog from './components/shop/modals/DiscoverByDialog.vue';
import DownloadAppHint from './components/pages/modals/DownloadAppHint.vue';
import CustomSocialsShare from './components/custom/CustomSocialsShare.vue';
import { isImpersonating,revertToSuperUser } from './utils/auth';
import EditShopTour from './components/shop/tours/EditShopTour.vue';

export default {
  name: 'App',
  components: {
    CustomTopSheetDialog,
    CustomTransitionButton,
    CreateShopNewsDialog,
    CompanyPostDialog,
    CustomProductLabel,
    ContactDialog,
    DiscoverByDialog,
    DownloadAppHint,
    CustomSocialsShare,
    EditShopTour
  },


  setup() {
    const countries = ref([]);
    const areas = ref([]);
    const showDiscoverDialog = ref(false)
    const discoverItems = ref([])
    const selectedCompanyFilter = ref(null)
    const { t, locale } = useI18n();
    const menuItems = [
      { label: t('global.menu.dealer.home'), url: 'shop/home' },
      { label: t('global.menu.dealer.favorites'), url: 'shop/favorites' },
      { label: t('global.menu.dealer.main'), url: 'shop/profile' },
      { label: t('global.menu.dealer.inbox'), url: '#' },
    ];

    if (isImpersonating.value) {
      console.log('You are impersonating a user');
    }
    const isMenuOpen = ref(false);
    provide("areas",areas)
    const discoverObject = ref({});
    const productCategories = ref([])
    const fetchProductCategories = async () => {
      try {
        const response = await proxy.$axios.get("/public/data/productcategories");
        if (response.data.status == "OK") {
          productCategories.value = response.data.data;
        }
      } catch (error) {
        console.error("Error: ", error);
      }
    }
    provide('productCategories', productCategories)
    const openProducerList = async (param) => {
      if (discoverObject.value[param.frontendId]) {
        discoverItems.value = discoverObject.value[param.frontendId];
        return;
      }
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");

      selectedCompanyFilter.value = param;


      try {
        const response = await proxy.$axios.get("/labels/" + param.frontendId,
          {
            headers: {
              'X-Auth-HARDTOKEN': hardToken,
              'X-Auth-SOFTTOKEN':softToken,
              'X-Auth-USER': username
            },
          },
        );
        if (response.data.status == "OK") {
          discoverObject.value[param.frontendId] = response.data.data;
          discoverItems.value = response.data.data;
        }
      } catch (error) {
        console.error("Error: ", error);
      }

    }

    const showDownloadAppHint = ref(false);


    const openDownloadAppHint = () => {
      showDownloadAppHint.value = true;
    }
    provide('openDownloadAppHint', openDownloadAppHint)

    const openDiscoverPopup = (item) => {
      showDiscoverDialog.value = true;
      discoverItems.value = item;
      openProducerList(item);
    }
    provide('openDiscoverPopup', openDiscoverPopup)



    const showContactDialog = ref(false);
    const showCompanyPostDialog = ref(false);
    const companyPost = ref(null);
    const merchant = ref(null);
    const openContactDialog = (item) => {
      showContactDialog.value = true;
      merchant.value = item;
    }
    provide('openContactDialog', openContactDialog)
    const openCompanyPost = (item) => {
      showCompanyPostDialog.value = true;
      companyPost.value = item;
    }
    provide('openCompanyPost', openCompanyPost)

    const shopNewsObject = ref(null)
    const selectedPost = ref(null);
    const postOverlay = ref(false);
    const showShopNewsDialog = ref(false);
    const createShopNews = (obj = null) => {
      showShopNewsDialog.value = true;
      shopNewsObject.value = obj;
    };
    provide('createShopNews', createShopNews);
    const openPostPopup = (item) => {
      console.log("openPostPopup",item)
      postOverlay.value = true;
      selectedPost.value = item;
    }
    provide('openPostPopup', openPostPopup);
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const activeIndex = ref(null);
    const languages = [
      { title: t('german'), img: '/images/flag-de.png', code: 'de' },
      { title: t('english'), img: '/images/flag-en.png', code: 'en' }
    ];
    const selectedLanguage = ref(languages.find(lang => lang.code === localStorage.getItem('selectedLanguage')) || { title: 'Deutsch', img: '/images/flag-de.png', code: 'de' });

    if (localStorage.getItem('selectedLanguage') == null && selectedLanguage.value != null) {
      localStorage.setItem('selectedLanguage', selectedLanguage.value.code)
    }

    provide('selectedLanguage', selectedLanguage);
    const locationFilter = ref(null)
    const selectedLocation = computed({
      get() {
        return Object.values(countries.value).find(country => country.id === (locationFilter.value != null ? locationFilter.value : selectedArea.value.countryId));
      },
      // set(newCountry) {
      //   if (newCountry && newCountry.id) {
      //     selectedArea.value.countryId = newCountry.id; // Update the reactive state
      //   }
      // }
    });

    // const selectedLocation = ref({
    //   "activeInFindeling": true,
    //   "areas": {
    //     "0349e515-00e9-47f8-abf2-df5524842ee5": "0349e515-00e9-47f8-abf2-df5524842ee5",
    //     "06722895-24c8-4e8a-bac3-8b83cfa9d7b3": "06722895-24c8-4e8a-bac3-8b83cfa9d7b3",
    //     "13d83bd4-03eb-4b73-96a5-fc31bea938a5": "13d83bd4-03eb-4b73-96a5-fc31bea938a5",
    //     "15f95ba8-a6a7-468e-b89a-abbe961b62df": "15f95ba8-a6a7-468e-b89a-abbe961b62df",
    //     "196193c8-3e4e-4b05-be3c-370319a4a8ae": "196193c8-3e4e-4b05-be3c-370319a4a8ae",
    //     "1bb556dc-e488-4292-9397-6d5686af3905": "1bb556dc-e488-4292-9397-6d5686af3905",
    //     "1d5444e7-d051-438b-a05d-8f43cb427300": "1d5444e7-d051-438b-a05d-8f43cb427300",
    //     "3043f732-b9d7-4383-9c40-386d10ef3b72": "3043f732-b9d7-4383-9c40-386d10ef3b72",
    //     "306ed900-1092-43c6-8f43-89831675fc22": "306ed900-1092-43c6-8f43-89831675fc22",
    //     "530f4438-d66e-4052-a499-43368c6b738a": "530f4438-d66e-4052-a499-43368c6b738a",
    //     "55b3c720-aa23-482f-895f-98b9d803acf9": "55b3c720-aa23-482f-895f-98b9d803acf9",
    //     "6326728d-5e8b-41a0-92de-adcb48f5bbee": "6326728d-5e8b-41a0-92de-adcb48f5bbee",
    //     "689de0ad-2d96-4383-8417-56c9b815ef55": "689de0ad-2d96-4383-8417-56c9b815ef55",
    //     "6e2edeee-2677-42b8-8882-be969948486e": "6e2edeee-2677-42b8-8882-be969948486e",
    //     "6fe80fc5-8800-45cb-9880-916ff9c31768": "6fe80fc5-8800-45cb-9880-916ff9c31768",
    //     "710f1ed7-b3d3-4209-ab69-556bc7160c94": "710f1ed7-b3d3-4209-ab69-556bc7160c94",
    //     "7393be91-2289-47d9-9001-eeb22b75a961": "7393be91-2289-47d9-9001-eeb22b75a961",
    //     "7d029e6e-0ebb-400c-ac4b-17fed46e40a2": "7d029e6e-0ebb-400c-ac4b-17fed46e40a2",
    //     "7f7e8e79-f452-4fca-aeae-b9c057a2d44b": "7f7e8e79-f452-4fca-aeae-b9c057a2d44b",
    //     "803bfb5f-461a-4806-938d-eaef82f293bd": "803bfb5f-461a-4806-938d-eaef82f293bd",
    //     "82d2e900-05b1-40dc-8014-c4a8cdd7aadc": "82d2e900-05b1-40dc-8014-c4a8cdd7aadc",
    //     "8c4fce20-1613-42d7-bd47-2e1ffe3ae13b": "8c4fce20-1613-42d7-bd47-2e1ffe3ae13b",
    //     "a438467a-6ef0-418e-b1cb-e832fd130e3e": "a438467a-6ef0-418e-b1cb-e832fd130e3e",
    //     "bf202623-9433-467a-82d0-e619eb9360cb": "bf202623-9433-467a-82d0-e619eb9360cb",
    //     "c9e08c32-7d6f-466a-8100-32dd4058b02e": "c9e08c32-7d6f-466a-8100-32dd4058b02e",
    //     "e9cf7d13-f17f-44b0-8102-5c5a7948dfcc": "e9cf7d13-f17f-44b0-8102-5c5a7948dfcc",
    //     "ec02e17b-0d6f-497a-9f6b-a34cbb69e7eb": "ec02e17b-0d6f-497a-9f6b-a34cbb69e7eb",
    //     "fd9fe985-0067-4b45-b3af-7e3b98f8bdd3": "fd9fe985-0067-4b45-b3af-7e3b98f8bdd3"
    //   },
    //   "code": "DE",
    //   "defaultArea": "fd9fe985-0067-4b45-b3af-7e3b98f8bdd3",
    //   "defaultLanguage": "de",
    //   "fairlingTarget": true,
    //   "id": "8e58050e-6fdf-4c13-b639-74c9bbf053a3",
    //   "shopsCount": 1577,
    //   "sortIndex": 1000,
    //   "translations": {
    //     "DE": "Deutschland",
    //     "EN": "Germany"
    //   },
    //   "vouchersAvailable": true
    // })
    const selectedArea = ref(
      {
        "activeInFindeling": true,
        "countryId": "8e58050e-6fdf-4c13-b639-74c9bbf053a3",
        "districtData": {
          "0108a3b3-2663-4ce3-89c4-cb9b55d9a33e": {
            "id": "0108a3b3-2663-4ce3-89c4-cb9b55d9a33e",
            "name": "Hoheluft",
            "numberOfShops": 8
          },
          "0155dabb-08bf-4653-aeec-078c1bd4b7d0": {
            "id": "0155dabb-08bf-4653-aeec-078c1bd4b7d0",
            "name": "Innenstadt",
            "numberOfShops": 52
          },
          "068f13cd-a6d3-4ec3-8a25-d74dc69f1b02": {
            "id": "068f13cd-a6d3-4ec3-8a25-d74dc69f1b02",
            "name": "Farmsen",
            "numberOfShops": 0
          },
          "0d0be295-5f9d-494f-a87c-edc0aa53cf74": {
            "id": "0d0be295-5f9d-494f-a87c-edc0aa53cf74",
            "name": "Rahlstedt",
            "numberOfShops": 1
          },
          "0fa8a79f-aa09-4730-9921-5bdbf9ea6631": {
            "id": "0fa8a79f-aa09-4730-9921-5bdbf9ea6631",
            "name": "Niendorf",
            "numberOfShops": 7
          },
          "10e6219c-ac1c-4ea3-8792-7e5885393164": {
            "id": "10e6219c-ac1c-4ea3-8792-7e5885393164",
            "name": "Groß-Flottbek",
            "numberOfShops": 2
          },
          "13bca83a-5ff6-46ba-8c59-993819de4282": {
            "id": "13bca83a-5ff6-46ba-8c59-993819de4282",
            "name": "Eppendorf",
            "numberOfShops": 56
          },
          "17b78854-12a9-4b5d-9b44-5bbcaabcde18": {
            "id": "17b78854-12a9-4b5d-9b44-5bbcaabcde18",
            "name": "Wilhelmsburg",
            "numberOfShops": 3
          },
          "1da62e4b-801e-4a8d-8931-4d9e80b34958": {
            "id": "1da62e4b-801e-4a8d-8931-4d9e80b34958",
            "name": "St. Georg",
            "numberOfShops": 6
          },
          "1e83c211-d615-4cbd-9e3d-2f30afdb98b0": {
            "id": "1e83c211-d615-4cbd-9e3d-2f30afdb98b0",
            "name": "Neustadt",
            "numberOfShops": 30
          },
          "21f52323-a8e9-4aca-88e8-4646a13c8dc3": {
            "id": "21f52323-a8e9-4aca-88e8-4646a13c8dc3",
            "name": "Altstadt",
            "numberOfShops": 83
          },
          "2854a369-0ced-4a85-90b1-c28a712c007e": {
            "id": "2854a369-0ced-4a85-90b1-c28a712c007e",
            "name": "Rotherbaum",
            "numberOfShops": 10
          },
          "28d478cd-53ea-4844-8fb6-a9b4c5259f1e": {
            "id": "28d478cd-53ea-4844-8fb6-a9b4c5259f1e",
            "name": "Norderstedt",
            "numberOfShops": 1
          },
          "2aee1e94-b7c9-4d1e-b47f-ff314a016490": {
            "id": "2aee1e94-b7c9-4d1e-b47f-ff314a016490",
            "name": "Marienthal",
            "numberOfShops": 1
          },
          "2c1f12fd-423b-4d67-807a-d872785b05fa": {
            "id": "2c1f12fd-423b-4d67-807a-d872785b05fa",
            "name": "Harvestehude",
            "numberOfShops": 9
          },
          "326520ca-d7a4-4d88-ad6c-9ecf9a0a8e78": {
            "id": "326520ca-d7a4-4d88-ad6c-9ecf9a0a8e78",
            "name": "Halstenbek",
            "numberOfShops": 1
          },
          "356a75ae-0575-406b-9fab-ab724977e636": {
            "id": "356a75ae-0575-406b-9fab-ab724977e636",
            "name": "Speicherstadt",
            "numberOfShops": 0
          },
          "3b31e104-e060-4446-8c64-f3107f747d4b": {
            "id": "3b31e104-e060-4446-8c64-f3107f747d4b",
            "name": "Hammerbrook",
            "numberOfShops": 1
          },
          "3f5e17b0-2aee-4feb-bd21-148ab92fbe01": {
            "id": "3f5e17b0-2aee-4feb-bd21-148ab92fbe01",
            "name": "Billstedt",
            "numberOfShops": 1
          },
          "48a4cc71-ee89-4c8d-951b-6be810d69ad1": {
            "id": "48a4cc71-ee89-4c8d-951b-6be810d69ad1",
            "name": "Bergedorf",
            "numberOfShops": 3
          },
          "4b71a961-8f4e-4b65-8bf3-53dd190a8e60": {
            "id": "4b71a961-8f4e-4b65-8bf3-53dd190a8e60",
            "name": "Alsterdorf",
            "numberOfShops": 2
          },
          "4b761a40-c2b6-468f-9025-3db7320dcdd5": {
            "id": "4b761a40-c2b6-468f-9025-3db7320dcdd5",
            "name": "Nienstedten",
            "numberOfShops": 4
          },
          "55da14ba-e158-4512-9492-7bed90fa60d0": {
            "id": "55da14ba-e158-4512-9492-7bed90fa60d0",
            "name": "Osdorf",
            "numberOfShops": 1
          },
          "58d3b9fb-356e-43a1-af95-3944bb9d0a06": {
            "id": "58d3b9fb-356e-43a1-af95-3944bb9d0a06",
            "name": "Harburg",
            "numberOfShops": 2
          },
          "5d94340f-c01b-475e-83ae-161d0d578cf7": {
            "id": "5d94340f-c01b-475e-83ae-161d0d578cf7",
            "name": "Blankenese",
            "numberOfShops": 15
          },
          "5f0228b9-dadf-4c8c-95aa-4d32a60f3106": {
            "id": "5f0228b9-dadf-4c8c-95aa-4d32a60f3106",
            "name": "Uhlenhorst",
            "numberOfShops": 15
          },
          "770e910f-321d-4dae-bd84-738830e9d742": {
            "id": "770e910f-321d-4dae-bd84-738830e9d742",
            "name": "Ottensen",
            "numberOfShops": 59
          },
          "793486b5-5779-4e67-9653-1b2dcba7131d": {
            "id": "793486b5-5779-4e67-9653-1b2dcba7131d",
            "name": "Schnelsen",
            "numberOfShops": 0
          },
          "7d1371fe-d716-40f6-9674-e7ba3104bc30": {
            "id": "7d1371fe-d716-40f6-9674-e7ba3104bc30",
            "name": "Duvenstedt",
            "numberOfShops": 2
          },
          "817dc170-fb34-4bf1-bc77-af713fdb4737": {
            "id": "817dc170-fb34-4bf1-bc77-af713fdb4737",
            "name": "Eidelstedt",
            "numberOfShops": 0
          },
          "85c361ad-2290-40ca-821d-040b787fd0c5": {
            "id": "85c361ad-2290-40ca-821d-040b787fd0c5",
            "name": "Altona",
            "numberOfShops": 20
          },
          "88225949-897e-4b8c-990f-7d0d0f5fb192": {
            "id": "88225949-897e-4b8c-990f-7d0d0f5fb192",
            "name": "Hamm",
            "numberOfShops": 3
          },
          "8a013308-54fb-414c-98f9-f066ff42a6e8": {
            "id": "8a013308-54fb-414c-98f9-f066ff42a6e8",
            "name": "Barmbek",
            "numberOfShops": 7
          },
          "8c81dee0-7b07-4de3-8f66-680a7627ded2": {
            "id": "8c81dee0-7b07-4de3-8f66-680a7627ded2",
            "name": "Lemsahl-Mellingstedt",
            "numberOfShops": 1
          },
          "8d0d383d-9237-4852-bf50-7f307ef99d59": {
            "id": "8d0d383d-9237-4852-bf50-7f307ef99d59",
            "name": "Hafencity",
            "numberOfShops": 2
          },
          "906696be-6bac-424a-8eef-b561aca61b9d": {
            "id": "906696be-6bac-424a-8eef-b561aca61b9d",
            "name": "Bramfeld",
            "numberOfShops": 3
          },
          "96d372c9-1bee-4e30-b052-524291c577b4": {
            "id": "96d372c9-1bee-4e30-b052-524291c577b4",
            "name": "Langenhorn",
            "numberOfShops": 2
          },
          "ad36ef8c-7cd4-4535-bc20-6cee8f2e1528": {
            "id": "ad36ef8c-7cd4-4535-bc20-6cee8f2e1528",
            "name": "St. Pauli",
            "numberOfShops": 64
          },
          "ae237016-c82c-4e7a-b14d-f0aa239d1c29": {
            "id": "ae237016-c82c-4e7a-b14d-f0aa239d1c29",
            "name": "Othmarschen",
            "numberOfShops": 15
          },
          "af06ce2a-abe7-4c68-a476-b75fff760a38": {
            "id": "af06ce2a-abe7-4c68-a476-b75fff760a38",
            "name": "Eimsbüttel",
            "numberOfShops": 71
          },
          "b1bf96ed-c488-49a5-a76d-d6766b8d9618": {
            "id": "b1bf96ed-c488-49a5-a76d-d6766b8d9618",
            "name": "Eilbek",
            "numberOfShops": 2
          },
          "bc196852-8877-4a20-a28b-46890faecfba": {
            "id": "bc196852-8877-4a20-a28b-46890faecfba",
            "name": "Hohenfelde",
            "numberOfShops": 1
          },
          "c45f24be-87f8-4d4d-b2e1-d0cf01506753": {
            "id": "c45f24be-87f8-4d4d-b2e1-d0cf01506753",
            "name": "Grindelviertel",
            "numberOfShops": 3
          },
          "c46a0113-5a76-4f5b-bb53-bc865185704a": {
            "id": "c46a0113-5a76-4f5b-bb53-bc865185704a",
            "name": "Schenefeld",
            "numberOfShops": 1
          },
          "c9183c78-9d26-43e2-a2c0-e855634905d5": {
            "id": "c9183c78-9d26-43e2-a2c0-e855634905d5",
            "name": "Pöseldorf",
            "numberOfShops": 0
          },
          "d81fbab7-1a76-49e8-a063-140876482ee1": {
            "id": "d81fbab7-1a76-49e8-a063-140876482ee1",
            "name": "Winterhude",
            "numberOfShops": 40
          },
          "d9b45391-5d38-4cd4-9eb5-b794b6f9ffe6": {
            "id": "d9b45391-5d38-4cd4-9eb5-b794b6f9ffe6",
            "name": "Bahrenfeld",
            "numberOfShops": 5
          },
          "df7af834-a3f5-465e-bd21-5d62cc247e92": {
            "id": "df7af834-a3f5-465e-bd21-5d62cc247e92",
            "name": "Lokstedt",
            "numberOfShops": 0
          },
          "e23dd86f-30df-4641-9a7b-d1b0e3cdfaad": {
            "id": "e23dd86f-30df-4641-9a7b-d1b0e3cdfaad",
            "name": "Poppenbüttel",
            "numberOfShops": 2
          },
          "e4a584c9-e5bb-44d1-9b82-eeb6b06f3e38": {
            "id": "e4a584c9-e5bb-44d1-9b82-eeb6b06f3e38",
            "name": "Karoviertel",
            "numberOfShops": 35
          },
          "e58f8db0-4e31-4ecd-8784-187fce3f18ec": {
            "id": "e58f8db0-4e31-4ecd-8784-187fce3f18ec",
            "name": "Sternschanze",
            "numberOfShops": 51
          },
          "efaf0c89-7a3f-4735-bedc-f56f62326452": {
            "id": "efaf0c89-7a3f-4735-bedc-f56f62326452",
            "name": "Stellingen",
            "numberOfShops": 2
          },
          "f1330864-ffa9-4a19-be88-22d3a2a7f180": {
            "id": "f1330864-ffa9-4a19-be88-22d3a2a7f180",
            "name": "Volksdorf",
            "numberOfShops": 8
          },
          "f858d5d4-bad6-47b9-a8d9-b1470a2dc2b1": {
            "id": "f858d5d4-bad6-47b9-a8d9-b1470a2dc2b1",
            "name": "Wandsbek",
            "numberOfShops": 3
          }
        },
        "districtNames": [
          "Hoheluft",
          "Innenstadt",
          "Farmsen",
          "Rahlstedt",
          "Niendorf",
          "Groß-Flottbek",
          "Eppendorf",
          "Wilhelmsburg",
          "St. Georg",
          "Neustadt",
          "Altstadt",
          "Rotherbaum",
          "Norderstedt",
          "Marienthal",
          "Harvestehude",
          "Halstenbek",
          "Speicherstadt",
          "Hammerbrook",
          "Billstedt",
          "Bergedorf",
          "Alsterdorf",
          "Nienstedten",
          "Osdorf",
          "Harburg",
          "Blankenese",
          "Uhlenhorst",
          "Ottensen",
          "Schnelsen",
          "Duvenstedt",
          "Eidelstedt",
          "Altona",
          "Hamm",
          "Barmbek",
          "Lemsahl-Mellingstedt",
          "Hafencity",
          "Bramfeld",
          "Langenhorn",
          "St. Pauli",
          "Othmarschen",
          "Eimsbüttel",
          "Eilbek",
          "Hohenfelde",
          "Grindelviertel",
          "Schenefeld",
          "Pöseldorf",
          "Winterhude",
          "Bahrenfeld",
          "Lokstedt",
          "Poppenbüttel",
          "Karoviertel",
          "Sternschanze",
          "Stellingen",
          "Volksdorf",
          "Wandsbek"
        ],
        "districts": [
          "0108a3b3-2663-4ce3-89c4-cb9b55d9a33e",
          "0155dabb-08bf-4653-aeec-078c1bd4b7d0",
          "068f13cd-a6d3-4ec3-8a25-d74dc69f1b02",
          "0d0be295-5f9d-494f-a87c-edc0aa53cf74",
          "0fa8a79f-aa09-4730-9921-5bdbf9ea6631",
          "10e6219c-ac1c-4ea3-8792-7e5885393164",
          "13bca83a-5ff6-46ba-8c59-993819de4282",
          "17b78854-12a9-4b5d-9b44-5bbcaabcde18",
          "1da62e4b-801e-4a8d-8931-4d9e80b34958",
          "1e83c211-d615-4cbd-9e3d-2f30afdb98b0",
          "21f52323-a8e9-4aca-88e8-4646a13c8dc3",
          "2854a369-0ced-4a85-90b1-c28a712c007e",
          "28d478cd-53ea-4844-8fb6-a9b4c5259f1e",
          "2aee1e94-b7c9-4d1e-b47f-ff314a016490",
          "2c1f12fd-423b-4d67-807a-d872785b05fa",
          "326520ca-d7a4-4d88-ad6c-9ecf9a0a8e78",
          "356a75ae-0575-406b-9fab-ab724977e636",
          "3b31e104-e060-4446-8c64-f3107f747d4b",
          "3f5e17b0-2aee-4feb-bd21-148ab92fbe01",
          "48a4cc71-ee89-4c8d-951b-6be810d69ad1",
          "4b71a961-8f4e-4b65-8bf3-53dd190a8e60",
          "4b761a40-c2b6-468f-9025-3db7320dcdd5",
          "55da14ba-e158-4512-9492-7bed90fa60d0",
          "58d3b9fb-356e-43a1-af95-3944bb9d0a06",
          "5d94340f-c01b-475e-83ae-161d0d578cf7",
          "5f0228b9-dadf-4c8c-95aa-4d32a60f3106",
          "770e910f-321d-4dae-bd84-738830e9d742",
          "793486b5-5779-4e67-9653-1b2dcba7131d",
          "7d1371fe-d716-40f6-9674-e7ba3104bc30",
          "817dc170-fb34-4bf1-bc77-af713fdb4737",
          "85c361ad-2290-40ca-821d-040b787fd0c5",
          "88225949-897e-4b8c-990f-7d0d0f5fb192",
          "8a013308-54fb-414c-98f9-f066ff42a6e8",
          "8c81dee0-7b07-4de3-8f66-680a7627ded2",
          "8d0d383d-9237-4852-bf50-7f307ef99d59",
          "906696be-6bac-424a-8eef-b561aca61b9d",
          "96d372c9-1bee-4e30-b052-524291c577b4",
          "ad36ef8c-7cd4-4535-bc20-6cee8f2e1528",
          "ae237016-c82c-4e7a-b14d-f0aa239d1c29",
          "af06ce2a-abe7-4c68-a476-b75fff760a38",
          "b1bf96ed-c488-49a5-a76d-d6766b8d9618",
          "bc196852-8877-4a20-a28b-46890faecfba",
          "c45f24be-87f8-4d4d-b2e1-d0cf01506753",
          "c46a0113-5a76-4f5b-bb53-bc865185704a",
          "c9183c78-9d26-43e2-a2c0-e855634905d5",
          "d81fbab7-1a76-49e8-a063-140876482ee1",
          "d9b45391-5d38-4cd4-9eb5-b794b6f9ffe6",
          "df7af834-a3f5-465e-bd21-5d62cc247e92",
          "e23dd86f-30df-4641-9a7b-d1b0e3cdfaad",
          "e4a584c9-e5bb-44d1-9b82-eeb6b06f3e38",
          "e58f8db0-4e31-4ecd-8784-187fce3f18ec",
          "efaf0c89-7a3f-4735-bedc-f56f62326452",
          "f1330864-ffa9-4a19-be88-22d3a2a7f180",
          "f858d5d4-bad6-47b9-a8d9-b1470a2dc2b1"
        ],
        "fairlingTarget": true,
        "id": "fd9fe985-0067-4b45-b3af-7e3b98f8bdd3",
        "identifier": "HH",
        "location": {
          "latitude": 53.5777,
          "longitude": 9.95353535353535
        },
        "name": "Hamburg",
        "properties": {
          "blogUrl": "http://blog.findeling.de/hamburg/",
          "eventsEnabled": "true",
          "facebookUrl": "https://www.facebook.com/findeling/",
          "initialStreamHeadline": "Moin Moin",
          "instagramUrl": "https://www.instagram.com/findelinghamburg/",
          "nameDE": "Hamburg",
          "nameEN": "Hamburg",
          "shopLocalDayEnabled": "false",
          "shopLocalDayLink": "https://shoplocalday.eu/wp-content/uploads/2020/09/Programmheft-Hamburg.pdf",
          "shopLocalDayProgrammeAvailable": "false",
          "shoppingTourUrl": "\"http://blog.findeling.de/shoppingtouren-hamburg/",
          "toursEnabled": "true",
          "type": "CITY"
        },
        "published": true,
        "sortOrder": 1,
        "urlName": "hamburg"
      }
    )
    const showInbox = ref(false);
    const locationType = ref('city');
    const countryList = ref(false);
    const instance = getCurrentInstance();
    const fetchingDone = ref(false);
    const initialize = ref(false);
    const shop = ref(null);


    provide('shop', shop);
    const setActive = () => {
      activeIndex.value = menuItems.findIndex(item => route.path.includes(item.url));
    };

    watch(() => route.path, setActive, { immediate: true });
    provide('selectedArea', selectedArea);

    const footerVisiblePaths = ['/home', '/shop/profile', '/shop/favorites', '/contact', '/login', '/fairling', '/password'];
    const dynamicRouteNames = ['CompanyShopProfile', 'CompanyProductProfile']
    const showFooter = computed(() => {

      // Check if the path matches a static path
      if (footerVisiblePaths.includes(route.path)) {
        return true;
      }

      // 2. Check for dynamic route names
      if (dynamicRouteNames.includes(route.name)) {
        return true;
      }

      return false;
    });

    const openTopDialog = () => {
      showInbox.value = true;
    }

    const selectOption = (option) => {
      selectedLanguage.value = option;
      locale.value = option.code;
      localStorage.setItem('selectedLanguage', option.code)
      window.location.reload();
      // menu = false; // close menu on selection
    }


    const updateSelectedAreaFromRoute = () => {
      const cityName = route.params.city; // Get the city name from the route

      
      // if (proxy.$checkLoggedIn()) return;
      if (!cityName) {
        // If there's no city in the URL, try getting the last selected city from localStorage
        const lastSelectedCity = localStorage.getItem('lastSelectedCity');
        if (lastSelectedCity) {
          const foundCity = instance.proxy.areas.find(
            (area) => area.urlName.toLowerCase() === lastSelectedCity.toLowerCase()
          );
          if (foundCity) {
            if (selectedArea.value.id != foundCity.id) {
              selectedArea.value = foundCity;
            }
            if (!route.path.includes('login') && !proxy.$checkLoggedIn()) {
              router.push(`/${selectedArea.value.urlName}`)

            }

          }
        } else {
          if (!route.path.includes('login')&& !proxy.$checkLoggedIn()) {
            router.push('/hamburg')
          }
        }
        return; // If there's no city in the URL and no last selected city, don't do anything
      } else {
        const foundCity = instance.proxy.areas.find(
          (area) => area.urlName.toLowerCase() === cityName?.toLowerCase()
        );

        const lastSelectedCity = localStorage.getItem('lastSelectedCity');

        const LastSelectfoundCity = instance.proxy.areas.find(
          (area) => area.urlName.toLowerCase() === cityName?.toLowerCase()
        );

        if (LastSelectfoundCity) {
          if (LastSelectfoundCity.id !== selectedArea.value.id) {
            selectedArea.value = LastSelectfoundCity;
          }
          setTimeout(() => {
            initialize.value = true;
          }, 500)
        }
        if (foundCity) {
          if (LastSelectfoundCity.id !== foundCity.id) {
            selectedArea.value = foundCity; // Set selected area
          }
          setTimeout(() => {
            initialize.value = true;
          }, 500)
        } else {
          console.warn(`City ${cityName} not found in area list.`);
          router.push({ name: 'NotFound' })
          setTimeout(() => {
            initialize.value = true;
          }, 500)
        }

      }


      // FIND COUNTRY FOR SELECTED AREA
      // console.log('Object.values(countries.value)', Object.values(countries.value))
      // if (Object.values(countries.value).length >= 1) {
      //   selectedLocation.value = Object.values(countries.value).find(country => country.id === selectedArea.value.countryId);
      //   console.log('FIND COUNTRY FOR SELECTED AREA', selectedLocation.value)
      // }

    };

    onMounted(() => {
      updateSelectedAreaFromRoute();
      fetchProductCategories();
    }),

      watch(fetchingDone, async (newVal, oldVal) => {
        if (newVal) {
          updateSelectedAreaFromRoute();
        }
      })

      watch(isImpersonating, async (newVal, oldVal) => {
        if (newVal) {
          console.log("fetchOwnShop because of isImpersonating", isImpersonating)
          proxy.fetchOwnShop();
        }
      })

    watch(selectedArea, async (newArea, oldArea) => {
      if (newArea.id != oldArea.id) {
        if (initialize.value) {
          localStorage.setItem('lastSelectedCity', newArea.name);
          router.replace(`/${newArea.urlName.toLowerCase()}`);
          // if (Object.values(countries.value).length >= 1) {
          //   selectedLocation.value = Object.values(countries.value).find(country => country.id === selectedArea.value.countryId);
          // }
          // window.location.reload();
        }
      }
    })

    const assignSelectedArea = (area) => {
      // router.replace(`/${area.urlName.toLowerCase()}`);
      // window.location.reload();
      selectedArea.value = area;
      locationFilter.value = null;
    }

    const selectCountry = (country) => {
      locationFilter.value = country.id;
      selectedLocation.value = country
    }

    const changeCountry = () => {
      if (countryList.value) {
        countryList.value = false;
        locationType.value = 'city';
      } else {
        countryList.value = true;
        locationType.value = 'countries';
      }
    }

    return {
      setActive,
      activeIndex,
      router,
      selectOption,
      selectedLanguage,
      openTopDialog,
      showInbox,
      locationType,
      changeCountry,
      selectedLocation,
      selectedArea,
      showFooter,
      fetchingDone,
      languages,
      shop,
      postOverlay,
      openPostPopup,
      selectedPost,
      selectCountry,
      countries,
      areas,
      showShopNewsDialog,
      createShopNews,
      shopNewsObject,
      showCompanyPostDialog,
      companyPost,
      openCompanyPost,
      openContactDialog,
      showContactDialog,
      merchant,
      showDiscoverDialog,
      discoverItems,
      openDiscoverPopup,
      selectedCompanyFilter,
      route,
      menuItems,
      isMenuOpen,
      showDownloadAppHint,
      assignSelectedArea,
      isImpersonating,
      revertToSuperUser,
      openDownloadAppHint

    }
  },

  data() {
    return {
      page: null,
      // languages: [
      //   { title: 'Deutsch', img: '/images/flags/flag_DE.png', code: 'DE' },
      //   { title: 'Englisch', img: '/images/flags/flag_EN.png', code: 'EN' }
      // ],
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      
    }
  },

  computed: {
    filteredCountries() {
      return Object.values(this.countries).filter(country => country.activeInFindeling == true)
    },
    filteredCityAreas() {
      // if(cityAreas.length == 0) this.locationType = ''
      return this.areas.filter(area => area.countryId === this.selectedLocation?.id && area.properties.type == "CITY");
    },
    filteredAreas() {
      return this.areas.filter(area => area.countryId === this.selectedLocation?.id && area.properties.type == "AREA");
    },

  },

  mounted() {
    this.fetchCountryData();
    this.fetchAreas();
    this.fetchMe();
    console.log("isImpersonating",isImpersonating.value)
    console.log("this.$checkLoggedIn()",this.$checkLoggedIn())
    if (this.$checkLoggedIn()) {
      this.fetchOwnShop();
    }
  },

  methods: {
    refreshElastic(){
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      this.$axios.get("/backoffice/refresh/elasticsearch", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
      })
        .then(this.elasticRefreshed)
        .catch(error => {
          console.error("Error fetching user data:", error);
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            // Optionally log the user out or redirect to login page
          }
        });
    },
    elasticRefreshed(response){
      this.$toast.success("Elastic Search refreshed")
    },
    fetchMe() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      this.$axios.get("/account/user", {
        headers: {
          'X-Auth-USER': username,
          'X-Auth-SOFTTOKEN':softToken,
          ...(hardToken != null ? {'X-Auth-HARDTOKEN': hardToken} : {})
        },
      })
        .then(this.userFetched)
        .catch(error => {
          console.error("Error fetching user data:", error);
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            // Optionally log the user out or redirect to login page
          }
        });
    },
    userFetched(response) {
      if (response.data.status == "OK") {
        this.$user.value = response.data.data
      }
    },
    fetchOwnShop() {
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      const softToken = localStorage.getItem("softToken");


      var _this = this;
      this.$axios.get("/shop", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
          
        },
      })
        .then(this.shopFetched)
        .catch(error => {
          console.error("Error fetching user data:", error);
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    shopFetched(response) {
      this.shop = response.data.data;
    },
    logout() {
      // Remove tokens from storage
      localStorage.removeItem("hardToken");
      localStorage.removeItem("username");
      sessionStorage.removeItem("softToken");
      localStorage.removeItem("bearer-jwt");
      this.$user.value = null;
      // Redirect to login page after logout
      // window.location.reload();
      this.$router.push("/");
    },
    test() {
      console.log("TEST");
    },
    fetchCountryData() {
      this.$dataAxios.get("/countrydata.json")
        .then(this.countryDataFetched)
        .catch()
    },
    countryDataFetched(response) {
      this.countries = response.data;
    },
    fetchAreas() {
      this.$dataAxios.get("/areas.json")
        .then(this.areasFetched)
        .catch()
    },
    areasFetched(response) {
      this.areas = Object.values(response.data);
      this.fetchingDone = true;
    }
  },
  provide() {
    return {
      fetchOwnShop: this.fetchOwnShop,
      fetchMe: this.fetchMe,
    }
  }
}
</script>

<style>
#app {
  font-family: Montserrat, sans-serif !important;
  /*text-align: center;*/
  color: #2c3e50;
  letter-spacing: normal !important;
}

body {
  font-size: 14px !important;
  font-family: Montserrat, sans-serif !important;
  font-weight: 300;
}

html.no-scroll {
  overflow: hidden;
}

p {
  color: #202020 !important;
  line-height: 1.5;
}

h3:not(:has(.footer *)) {
  font-family: Manrope, sans-serif !important;
  color: #202020 !important;
  font-weight: 700 !important;
  font-size: 17px !important;
  line-height: 1.3 !important;
}

.v-overlay__scrim {
  background: rgba(196, 196, 196, 0.822) !important;
  opacity: 1 !important;
}

.v-field__field input {
  font-size: 14px !important;
}

.v-main {
  padding-top: 48px !important;
  /* 
  min-height: 100vh;
  */
}

.v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}

.nav-buttons .v-btn:hover {
  color: rgb(var(--v-theme-primary));
  /* Keep the original text color */
  box-shadow: none !important;
  /* Remove hover shadow if present */
}

.nav-btn.active {
  color: rgb(var(--v-theme-primary));
  /* Highlight text color */
  border-radius: 4px;
}

.logo.filter {
  filter: invert(10%) sepia(13%) saturate(6706%) hue-rotate(161deg) brightness(85%) contrast(93%);
}

.logo {
  width: 120px;
  cursor: pointer;
}

a.v-list-item {
  text-decoration: none;
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity)) !important;
}

.footer {
  background-color: #202020;
}

.footer h3 {
  margin-top: 0 !important;
  margin-bottom: 0.5rem !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  font-size: 1.75rem !important;
  color: var(--bs-heading-color) !important;
}

.footer-list .v-list-item-title {
  color: rgba(255, 255, 255, .75);
  font-size: 12px;
  letter-spacing: 1px;
}

.footer-list .v-list-item {
  min-height: 20px !important;
  padding-inline: 0;
  padding: 1px 0px;
}

.footer-list .v-list-item:hover .v-list-item-title {
  color: #51b7d6;
}

.footer-list .v-list-item:hover {
  color: transparent;
}

.footer-container .v-list .v-list-item {
  padding-left: 0px !important;
}

.footer-container {
  width: 1170px;
}

.footer-container .footer-socials {
  margin: 0 15px;
  display: flex;
  gap: 30px;
  flex-direction: row;
  justify-content: space-around;
}

.main-nav .v-toolbar__content {
  margin: auto;
  max-width: 1170px;
  height: 50px !important;
}

.main-nav .v-btn {
  padding: 0px 4px;
}

.main-nav .v-btn:hover {
  color: black !important;
  background-color: transparent !important;
}

.language-picker .active {
  background-color: rgb(var(--v-theme-primary));
  color: white;
}

.clickable {
  cursor: pointer;
}

.region-selector.v-btn {
  margin-left: 20px;
}

.post-popup .news-post-info .news-post-text {
  color: #202020;
  font-weight: 300;
}

.post-popup .news-post-info .post-start {
  font-size: 12px;
}

.post-popup .news-post-info span {
  color: #202020;
  font-weight: 200;
  font-size: 10px;
}

.v-tour__target--highlighted{
  box-shadow: 0 0 0 9999px #0006 !important;
  z-index: 1005 !important;
}

.v-step{
  z-index: 1008 !important; 
}

.ng-hide{
  display:none;
}
</style>
